<template>
  <input type="password" hidden autocomplete="new-password">
  <!--   登录-->
  <div ref="modelDom" class="modal fade" id="loginModal" tabindex="-1" aria-labelledby="loginModalLabel" aria-hidden="true"
       data-bs-keyboard="false" data-bs-backdrop="static">
    <!--  <div class="modal" tabindex="-1">-->
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary position-relative text-white">
          <h1 class="modal-title  fw-bold  fs-5  text-center w-100" id="loginModalLabel">登录</h1>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 px-4 " @click="loginModelOpen(false)"></button>
        </div>
        <div class="modal-body">

          <form class="needs-validation" @submit.prevent="save" ref="formDom" novalidate autocomplete="off">
            <!--          账号-->
            <div class="row my-3">
              <div class="col-12 ">
                <div class="input-group ">
                  <span class="input-group-text d-flex align-items-center justify-content-center bg-white " id="basic-addon1">
                    <img src="../assets/images/login1.png" alt="">
                  </span>
                  <input type="text" placeholder="用户名/手机号" id="account" autocomplete="off" name="account" v-model="form.account"  class="form-control bg-white" required >
                </div>
                <div class="invalid-feedback">
                  请输入账号
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 ">
                <div class="input-group ">
                  <span class="input-group-text d-flex align-items-center justify-content-center bg-white " id="basic-addon1">
                    <img src="../assets/images/login2.png" alt="">
                  </span>
                  <input type="password"
                         autocomplete="off"
                         name="password"
                         placeholder="密码"
                         id="password" v-model="form.password" class="form-control bg-white"
                         aria-describedby="passwordHelpInline" required>
                </div>
                <div class="invalid-feedback">
                  请输入密码
                </div>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col d-flex align-items-start justify-content-between">
                <div class="left flex-fill me-3">
                  <div class="input-group ">
                  <span class="input-group-text d-flex align-items-center justify-content-center bg-white " id="basic-addon1">
                    <img class="img" src="../assets/images/login3.png" alt="">
                  </span>
                    <input type="captcha" id="captcha" name="captcha" v-model="form.captcha" class="form-control"
                           aria-describedby="captcha"
                           placeholder="验证码"
                           required>
                  </div>
                  <div class="invalid-feedback">
                    请输入验证码
                  </div>
                </div>
                <div class="d-flex flex-column img-box" style="width: 100px;height: 3rem">
                  <img :src="base64" alt="点击获取" class="border-1 border point-curser code-img flex-shrink-0" @click="getCaptchaFun">
                  <a class="small text-primary point-curser mt-2" @click="getCaptchaFun">
                    看不清？
                  </a>
                </div>
              </div>


            </div>
            <div class="row mt-4">
              <div class="col-12">
                <button class=" btn btn-md btn-primary w-100 py-2" type="submit"
                        :disabled="loading || !(form.account &&form.account.trim() && form.password&&form.password.trim() && form.captcha&&form.captcha.trim())" >
                  <span v-if="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                  登录
                </button>
              </div>
            </div>

          </form>
          <div class="row mt-3 px-5">
            <div class="col-12 d-flex align-items-center justify-content-between">
              <a class="small fw-bold text-primary point-curser" @click="registModelOpen(true)">注册</a>
              <a class="small fw-bold text-primary point-curser" @click="findPasswordOpen(true)">找回密码</a>
            </div>
          </div>
<!--          <div class="card-footer p-2 text-center"><small>没有注册?</small>-->
<!--            <a class="small font-weight-bold text-primary point-curser" @click="registModelOpen(true)">创建账号</a></div>-->
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import {reactive, onMounted, ref,watch,defineProps,defineEmits} from 'vue'
import {Modal} from 'bootstrap'
import {registModelOpen,loginModelOpen,findPasswordOpen} from "@/utils/authCheck"
import {useStore} from 'vuex'
import {accountLogin, getCaptcha} from "@/api/login";
import {showToast} from "@/utils/toast";
import {setToken} from "@/utils/token";
const store = useStore()
const modelDom = ref() // 当前model
let modelRef; // model实例
const formDom = ref()
const loading = ref(false)
const base64 = ref('')
let captchaId = null // 当前验证码的id
const form = reactive({
  account:"",
  password:null,
  captcha:null,
})
// 监测登录的模块
watch(() => store.state.manuAction.loginModelOpen,(now, prev) => {
  openLoginCtr && openLoginCtr(now?"open":"close")
},{ deep: true})
// 打开或者关闭
const openLoginCtr = (flag)=>{
  if(!modelRef && modelDom.value){
    modelRef = new Modal(modelDom.value)
  }
  if(flag==="open"){
    modelRef.show()
    getCaptchaFun()
  }else if(flag==='close'){
    modelRef.hide()
  }else{
    modelRef.toggle()
  }
}

const props = defineProps({
  show: {
    default: false
  }
})

// 获取验证码
const getCaptchaFun = async ()=>{
  const res = await getCaptcha()
  if(res.err_code==0){
    captchaId = res.data.captchaId
    base64.value = res.data.image
  }else{
    captchaId = ""
    base64.value = ""
    showToast("danger","获取验证码失败！")
  }
}

const emits = defineEmits({
  'update:show': (val) => {
    return val;
  },
  'closeMode': (val) => {
    return val;
  },
  "goRegister": (val) => {
    return val;
  },
})

//提交
const save =async (event)=>{
  event.preventDefault();
  event.stopPropagation();
  const params = {...form,captchaId:captchaId}
  loading.value = true
  const res = await accountLogin(params)
  loading.value = false
  if(res.err_code === 0){
    setToken(res.data)// 保存token
    store.commit("loginModel/login", true) // 修改state
    showToast("success", "登录成功")
    loginModelOpen(false)
  await store.dispatch("loginModel/getUserInfo") //获取用户信息
  }else{
    showToast("danger",res.err_msg || "账号或密码错误")
    getCaptchaFun() // 重新获取验证码
  }
  console.log(res)
  // // 验证表单
  // const formD = formDom.value
  //
  // // form.classList.add('was-validated');
  // if (formD.checkValidity() === false) {
  //   return false
  // }
  // const data = {};
  // const formData = new FormData(event.target)
  // formData.forEach((value, key) => {
  //   data[key] = value;
  // });
  // console.log(data,form)
}

onMounted(()=>{
  getCaptchaFun() // 获取base64验证码
  const formD = formDom.value
  formD.reset()
  form.account = ""
  modelRef = new Modal(modelDom.value)

})



</script>

<style scoped lang="scss">
.form-control{
  height: 3rem;
}
.img-box > img{
  width: 100%;
  height: 100%;
  object-fit: fill; /* 保持图片比例且填满容器 */
}
.input-group{
  input{
    border-left: none !important;
  }
}
.input-group-text{
  width: 3rem;
  border-right: none;
  img{
    width: 13px;
    height: 16px;
    object-fit: fill; /* 保持图片比例且填满容器 */
  }
  .img{
    width: 16px;
    height: 13px;
    object-fit: fill; /* 保持图片比例且填满容器 */
  }
}
</style>
